// Planification : tâches de l'équipe, planning de production, maintenance préventive, planning des livraisons.
import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Badge, Tab, Tabs } from '@mui/material';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/Layout';
import { planningAPI } from '../../services/api';
import Taches from './Taches';
import ProductionPlan from './ProductionPlan';
import Maintenance from './Maintenance';
import Livraisons from './Livraisons';
import Personnel from './Personnel';
import Intrants from './Intrants';

const Planification = () => {
  const { onglet = 'taches', id } = useParams();
  const navigate = useNavigate();
  const [r, setR] = useState(null);
  const [info, setInfo] = useState('');
  const refresh = useCallback(() => planningAPI.resume().then((x) => setR(x.data)).catch(() => {}), []);
  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => { if (!info) return undefined; const t = setTimeout(() => setInfo(''), 5000); return () => clearTimeout(t); }, [info]);

  if (!r) return <Layout title="Planification" plain />;
  const onglets = [
    { v: 'taches', l: 'Tâches', n: r.mes_taches, rouge: r.mes_retards > 0 },
    r.terrain && { v: 'production', l: 'Production' },
    { v: 'maintenance', l: 'Maintenance', n: r.maintenances_dues, rouge: true },
    r.terrain && { v: 'livraisons', l: 'Livraisons', n: r.livraisons_jour },
    r.personnel && { v: 'personnel', l: 'Personnel' },
    r.intrants && { v: 'intrants', l: 'Intrants' },
  ].filter(Boolean);
  if (!onglets.some((o) => o.v === onglet)) return <Navigate to="/planification/taches" replace />;
  const props = { id: id ? Number(id) : null, onInfo: setInfo, refreshResume: refresh, responsable: r.responsable };

  return (
    <Layout title="Planification" plain>
      <Tabs value={onglet} onChange={(e, v) => navigate(`/planification/${v}`)} variant="scrollable" sx={{ mb: 2 }}>
        {onglets.map((o) => (
          <Tab key={o.v} value={o.v} label={o.n ? <Badge color={o.rouge ? 'error' : 'primary'} badgeContent={o.n} sx={{ '& .MuiBadge-badge': { right: -12 } }}>{o.l}</Badge> : o.l} sx={{ pr: o.n ? 3.5 : undefined }} />
        ))}
      </Tabs>
      {info && <Alert severity="success" sx={{ mb: 2 }} onClose={() => setInfo('')}>{info}</Alert>}
      {onglet === 'taches' && <Taches {...props} />}
      {onglet === 'production' && <ProductionPlan {...props} />}
      {onglet === 'maintenance' && <Maintenance {...props} />}
      {onglet === 'livraisons' && <Livraisons {...props} />}
      {onglet === 'personnel' && <Personnel {...props} />}
      {onglet === 'intrants' && <Intrants {...props} />}
    </Layout>
  );
};

export default Planification;
